import { DSOrganizations } from '../../../cimsPage/instances/ds'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const orgs = CreateViewEditSoftRemoveRestore({
  object: 'Organization',
  page: DSOrganizations,
  create: '8fd96e73-6c2d-4142-9823-83017399cb34',
  view: '6e6c586b-d4ca-4009-9421-a06c95e7339d',
  edit: '70657777-4c55-42a4-a959-8fb09bc83336',
  removeRestore: '6c134b6a-b5d3-41ae-9411-4f2e031c2a64',
})

export const CreateDesignSubmittalOrganization = orgs.Create
export const ViewDesignSubmittalOrganization = orgs.View
export const EditDesignSubmittalOrganization = orgs.Edit
export const RemoveRestoreDesignSubmittalOrganization = orgs.RemoveRestore

export type DSOrganizationPermissions =
  | typeof CreateDesignSubmittalOrganization
  | typeof ViewDesignSubmittalOrganization
  | typeof EditDesignSubmittalOrganization
  | typeof RemoveRestoreDesignSubmittalOrganization
